import React, {lazy, Suspense} from 'react';
import styled from 'styled-components';
import Spinner from '@atlaskit/spinner';

const PlanDetailsApp = lazy(() => import( './pricingplan/plan-details-app'));
const LandingPageApp = lazy(() => import( './landingpage/landing-page-app'));
const PullrequestCard = lazy(() => import('./pullrequest/pullrequest-card'));
const NudgingPopup = lazy(() => import('./nudging/nudging-popup'));

export default function RoutableApp({target}) {
    return (
        <Suspense fallback={<AppLoadingIndicator/>}>
            {getApp(target)}
        </Suspense>
    );
}

function getApp(target) {
    if (target === 'landingpage') {
        return <LandingPageApp/>;
    } else if (target === 'pullrequest-card') {
        return <PullrequestCard/>;
    } else if (target === 'nudging') {
        return <NudgingPopup/>;
    } else {
        return <PlanDetailsApp/>;
    }
}

const AppLoadingIndicator = () => (
    <CenteredContent>
        <Spinner size={'medium'}/>
    </CenteredContent>
)

const CenteredContent = styled.div`
    width: 100%;
    text-align: center;
`
